<template>
<v-container ref="pageBanks" fluid tag="section">
    <material-card icon="mdi-bank" icon-small title="Банки" color="accent" class="mb-16">
    </material-card>
    <v-simple-table>
        <thead>
            <tr>
                <th class="primary--text" width="20">
                    ID
                </th>
                <th class="primary--text" width="30%">
                    Назва
                </th>
                <th class="primary--text" width="10%">
                    Код
                </th>
                <th class="primary--text" width="20%">
                    Тип кредиту
                </th>
                <th class="primary--text" width="100">
                    Зображення
                </th>
                <th class="primary--text" width="10">
                    Включено
                </th>
                <th width="50"></th>
            </tr>
        </thead>

        <tbody v-if="banks.length">
            <tr v-for="(bank, index) in banks" :key="bank.id">
                <td>{{ bank.id }}</td>
                <td>{{ bank.name }}</td>
                <td>{{ bank.code }}</td>
                <td>{{ bank.credit_type }}</td>
                <td>
                  <v-img contain height="50" width="200" :src="`${imageBaseUrl}${bank.image}`"></v-img>
                </td>
                <td><v-icon v-if="bank.enabled">mdi-check</v-icon></td>
                <td>
                    <span class="d-flex">
                        <v-icon v-if="isManager || isAdmin" class="mr-4" color="green" @click="$router.push(`/banks/${bank.id}/`)">
                            mdi-pencil
                        </v-icon>
                        <v-icon v-if="isAdmin" color="error" @click="deleteBank(bank.id)">
                            mdi-delete
                        </v-icon>
                    </span>
                </td>
            </tr>
        </tbody>
    </v-simple-table>

    <!--Пагинация-->
    <div v-if="pagesCount >= 1" class="text-center py-4">
        <v-pagination @input="setQueryParam(pageCurrent)" v-model="pageCurrent" :total-visible="9" :length="pagesCount"></v-pagination>
    </div>
    <DialogConfitmDelete ref="dialogConfirmDelete" />
    <Preloader v-if="isSending" />
    <v-btn
      v-if="isManager || isAdmin"
      class="add-user__button"
      fab
      dark
      color="primary"
      to="/banks/add/"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>


</v-container>
</template>
<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

  export default {
    name: 'RegularTablesView',
    data() {
      return {
        // Список банків
        banks: [],
        // Тецущий проект
        project: {},
        mis: null,
        // Текущая страница
        pageCurrent: null,
        // Количество акций на странице
        pageLimitItems: 10,
        // Количество страниц
        pagesCount: 1,
        // Выполняется отправка на сервер
        isSending: false,
        imageBaseUrl: `${IMAGE_BASE_URL}banks/`
      }
    },
    computed: {
      ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
      this.init();
    },

    watch: {
      // Сделано через watch  чтобы отслеживать переходы вне страницы (например если пользователь нажмёт в меню /banks/)
      '$route': {
        handler() {
          this.getBanks();
        },
        deep: true,
      }
    },

    methods: {
      ...mapMutations(['setSnackbar']),
      ...mapActions(['getProjects']),

      async init() {
        await this.getProjects();
        await this.getBanks();
      },

      // Получить список 
      async getBanks() {
        let { project = null, type = null, mechanic = null, mis = null, page = 1 } = this.$route.query;
        this.project = this.projects.find((el) => el.id == project);
        this.mis = mis;
        this.pageCurrent = +page;

        try {
          let { data } = await HTTP.post('/get-list-banks', { 
            limit: this.pageLimitItems,
            page,
          });
  
          this.banks = data?.content?.data || [];
          this.pagesCount = data?.content?.pagination?.pages || 1;
        } catch(error) {
          console.warn(error);
        }
      },
      // Добавляем query параметры в урл
      setQueryParam(page = 1) {
        this.pageCurrent = page;
        let query = {
          project: this.project?.id,
          mis: this.mis,
          page: this.pageCurrent
        };

        for(let key in query) {
          if (!query[key] || (key === 'page' &&  query?.page <= 1)) {
            delete query[key];
          }
        };

        let query1 = JSON.stringify(query).split('"').join('');
        let query2 = JSON.stringify(this.$route.query).split('"').join('');

        if (query1 != query2) {
          this.$router.push({ query });
        }
        return query;
      },

      // Удалить bank
      async deleteBank(bankId) {
        let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
        if (!isConfirmDelete) return;
        this.isSending = true;

        try {
          await HTTP.post('/delete-bank', { id: bankId });
          this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
          this.getBanks();
        } catch(error) {
          console.warn(error);
          this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
        } finally {
          this.isSending = false;
        }
      },
    },
  }

</script>

<style>
.add-user__button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>

